import React, { Component } from 'react';
import Properties from '../component/Properties';
import styles from '../css/styles.css.js';
import QMlogo from '../images/png/EQM.png';
import ESlogo from '../images/png/ES-Logo.png';
import profilePic from '../images/png/profilePicture.png';
import SFlogo from '../images/png/SF-Logo.png';
import { AppSetting, AppProperties } from '../common/function';

export default class UserProfile extends Component {
  AppSetting = AppSetting();
  appProperties = AppProperties();

  universitySuffix = this.AppSetting && this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX 
  ? (this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX.includes("lti") ? this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX.replace("_lti", " (carmen)") : this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX)
  : ""

  render() {
    let roles = ['Student', 'Instructor', 'Administrator'];

    const host = window.location.host;

    let url = 'https://stemfluency.org/'
    // update url if the host is test site
    if (host.includes('dev.')) {
      url = 'https://dev.stemfluency.com/'
    }
    
    return (
       <div style={styles.navigationHeader} name="UserHeader">
        <div style={styles.drawerTitleColor}>
          {this.props.eqmMode?
            <img className="image-fit-width" alt="EQM" title="EQuizMaster" src={QMlogo} />
                :
            (this.props.loginType === 'form' ?
            <>
            <a href={url} target="_blank"><img className="image-fit-width" alt="Stem Fluency" title="Stem Fluency" src={SFlogo} /></a>
            </>
            :
            <>
            <img className="image-fit-width" alt="Essential Skills" title="Essential Skills" src={ESlogo} />
            </>
            )
          }
        </div>
        <div style={styles.profileContainer}>
          <div style={styles.instructortable}>
            <div style={styles.picContainer}>
              <img style={styles.avatar} src={profilePic} alt="Profile" title="Profile" />
            </div>
            <div style={styles.profileTextContainer}>
              <p style={styles.instructor}>{this.props.givenName}</p>
              <p style={styles.instructorName}>{roles[this.props.role]}, <small>{this.universitySuffix.toUpperCase()}</small></p>
              {/* bug id 163 Checked "logout" to "Logout" - Capital L*/}
              {this.appProperties.enableLogin ? (
                 <button  style={styles.logout} className='ButtonLink' onClick={this.props.logout.bind(this)}>Logout</button>
                
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
